import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AppAdminGuardService implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  async canActivate() {
    if (!this.authService.getIsAdmin) {
      this.router.navigate(['home']);
      return false;
    } else {
      return true;
    }
  }
}
